export default {"src":"/_next/static/media/loading.71102b5f.gif","height":500,"width":500};